module.exports = __webpack_public_path__ + "static/media/top-img_4_mob@2x.f80c1d3f.png";